export const Card = ({ className = "", children, ...props }) => (
  <div
    className={`rounded-2xl border border-white/10 bg-[#14141A]/80 p-6 ${className}`}
    {...props}
  >
    {children}
  </div>
);

export const PageTitle = ({ title, sub }) => (
  <div>
    <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">{title}</h1>
    {sub && <p className="mt-2 text-sm text-[#99A1AF]">{sub}</p>}
  </div>
);

export const Stat = ({ label, value, sub, gold = false, testId }) => (
  <Card data-testid={testId}>
    <p className="font-mono text-[10px] tracking-[0.25em] text-[#636B78] uppercase">{label}</p>
    <p className={`mt-3 font-display text-2xl sm:text-3xl font-bold tracking-tight ${gold ? "text-gold-gradient" : "text-white"}`}>
      {value}
    </p>
    {sub && <p className="mt-1.5 text-xs text-[#636B78]">{sub}</p>}
  </Card>
);

export const Loading = ({ label = "Loading" }) => (
  <div className="flex items-center gap-3 py-16 text-[#636B78]">
    <span className="h-4 w-4 animate-spin rounded-full border-2 border-[#D4AF37]/30 border-t-[#D4AF37]" />
    <span className="text-sm">{label}…</span>
  </div>
);

export const ErrorBox = ({ message }) => (
  <div className="rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300" data-testid="error-box">
    {message}
  </div>
);
